import { makeLpTitle } from "@utils/makeLpTitle";

export const buildArticleMeta = (type, name, category) => {
  const contentType = type === "Travel News" ? "news" : "feature";
  const captialFirst = catArray => {
    if (catArray) {
      const categorySplit = catArray ? catArray.split(" ") : "";
      return categorySplit
        .map(cat => {
          if (cat === "and") {
            return cat;
          }
          return cat[0].toUpperCase() + cat.substring(1);
        })
        .join("  ");
    }
    return catArray;
  };

  const capGrammar =
    category !== null && category !== "Beaches coasts and islands"
      ? captialFirst(category)
      : "Beaches, Coasts and Islands";

  const values = {
    news: {
      default: {
        title: makeLpTitle(type),
        desc: "Be inspired every day by the latest travel news and discover the best new and unusual openings, tours, accommodation and trends to fuel your wanderlust.",
      },
      place: {
        title: makeLpTitle(`${name} News`),
        desc: `Be inspired by the latest travel news from ${name} and discover the best new and unusual openings, tours, accommodations and trends to fuel your wanderlust.`,
      },
      category: {
        title: makeLpTitle(`${capGrammar} ${type}`),
        desc: `Get the latest ${category} news and discover the best new and unusual openings, tours, accommodations and trends to fuel your wanderlust.`,
      },
      place_category: {
        title: makeLpTitle(`${capGrammar} ${type} in ${name}`),
        desc: `Read the latest ${category} news from ${name} to hear about current travel trends and discover the best new in-destination experiences.`,
      },
    },
    feature: {
      default: {
        title: makeLpTitle("Stories"),
        desc: "Discover amazing travel experiences with Lonely Planet’s insider tips, inspirational traveler stories and expert guidance from around the world.",
      },
      place: {
        title: makeLpTitle(`${name} Travel Stories `),
        desc: `Discover amazing travel experiences in ${name} with Lonely Planet's insider tips, inspirational traveler stories and expert guidance from around the world.`,
      },
      category: {
        title: makeLpTitle(`${capGrammar} Stories`),
        desc: `Plan your next life-changing travel experience with Lonely Planet’s latest ${category} stories from around the world.`,
      },
      place_category: {
        title: makeLpTitle(`${capGrammar} Stories in ${name}`),
        desc: `Connect with the latest ${category} stories from ${name} to discover the best new in-destination experiences according to Lonely Planet.`,
      },
    },
  };

  let variation = "default";
  if (name && !category) variation = "place";
  if (!name && category) variation = "category";
  if (name && category) variation = "place_category";
  return values[contentType][variation];
};
